"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.scheduleReport = exports.getUserReportsSuccess = exports.getUserReportsRequested = exports.getUserReports = exports.getUserReportWriterResultsSuccess = exports.getUserReportWriterResultsRequested = exports.getUserReportWriterResults = exports.generateReport = exports.cancelReport = exports.addReport = exports.GET_USER_REPORT_WRITER_RESULTS_SUCCESS = exports.GET_USER_REPORT_WRITER_RESULTS_REQUESTED = exports.GET_USER_REPORT_WRITER_RESULTS_ERROR = exports.GET_USER_REPORTS_SUCCESS = exports.GET_USER_REPORTS_REQUESTED = exports.GET_USER_REPORTS_ERROR = exports.ADD_REPORT = void 0;
var _apiActions = require("./apiActions");
var _snackbarActions = require("./snackbarActions");
var _sidePaneActions = require("./sidePaneActions");
var _errorTextFormatter = require("../../helpers/errorTextFormatter");
var _dateFns = require("date-fns");
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var GET_USER_REPORTS_REQUESTED = exports.GET_USER_REPORTS_REQUESTED = 'GET_USER_REPORTS_REQUESTED';
var GET_USER_REPORTS_SUCCESS = exports.GET_USER_REPORTS_SUCCESS = 'GET_USER_REPORTS_SUCCESS';
var GET_USER_REPORTS_ERROR = exports.GET_USER_REPORTS_ERROR = 'GET_USER_REPORTS_ERROR';
var GET_USER_REPORT_WRITER_RESULTS_REQUESTED = exports.GET_USER_REPORT_WRITER_RESULTS_REQUESTED = 'GET_USER_REPORT_WRITER_RESULTS_REQUESTED';
var GET_USER_REPORT_WRITER_RESULTS_SUCCESS = exports.GET_USER_REPORT_WRITER_RESULTS_SUCCESS = 'GET_USER_REPORT_WRITER_RESULTS_SUCCESS';
var GET_USER_REPORT_WRITER_RESULTS_ERROR = exports.GET_USER_REPORT_WRITER_RESULTS_ERROR = 'GET_USER_REPORT_WRITER_RESULTS_ERROR';
var ADD_REPORT = exports.ADD_REPORT = 'ADD_REPORT';
var getUserReports = exports.getUserReports = function getUserReports(UserId) {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(dispatch) {
      var reports;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            dispatch(getUserReportsRequested());
            _context.n = 1;
            return dispatch((0, _apiActions.callAPI)('GetUserReportTickets', {
              UserId: UserId
            }));
          case 1:
            reports = _context.v;
            dispatch(getUserReportsSuccess(reports));
          case 2:
            return _context.a(2);
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};
var getUserReportsRequested = exports.getUserReportsRequested = function getUserReportsRequested() {
  return {
    type: GET_USER_REPORTS_REQUESTED
  };
};
var getUserReportsSuccess = exports.getUserReportsSuccess = function getUserReportsSuccess(payload) {
  return {
    type: GET_USER_REPORTS_SUCCESS,
    payload: payload
  };
};
var getUserReportWriterResults = exports.getUserReportWriterResults = function getUserReportWriterResults() {
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(dispatch, getState) {
      var UserId, reports;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.n) {
          case 0:
            UserId = getState().user.userInfo.UserId;
            dispatch(getUserReportWriterResultsRequested());
            _context2.n = 1;
            return dispatch((0, _apiActions.callAPI)('GetUserReportWriterResultRecords', {
              UserId: UserId
            }));
          case 1:
            reports = _context2.v;
            dispatch(getUserReportWriterResultsSuccess(reports));
          case 2:
            return _context2.a(2);
        }
      }, _callee2);
    }));
    return function (_x2, _x3) {
      return _ref2.apply(this, arguments);
    };
  }();
};
var getUserReportWriterResultsRequested = exports.getUserReportWriterResultsRequested = function getUserReportWriterResultsRequested() {
  return {
    type: GET_USER_REPORT_WRITER_RESULTS_REQUESTED
  };
};
var getUserReportWriterResultsSuccess = exports.getUserReportWriterResultsSuccess = function getUserReportWriterResultsSuccess(payload) {
  return {
    type: GET_USER_REPORT_WRITER_RESULTS_SUCCESS,
    payload: payload
  };
};
var createParamsForOneOffReport = function createParamsForOneOffReport(getState, formValues) {
  var OMSId = getState().user.userInfo.OMSId;
  return {
    OMSId: OMSId,
    startTime: (0, _dateFns.addDays)(formValues.startDate, 1),
    endTime: (0, _dateFns.addDays)(formValues.endDate, 1),
    accountIdList: formValues.accountIdList
  };
};
var generateReport = exports.generateReport = function generateReport(formValues) {
  return /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(dispatch, getState) {
      var params, response, _t;
      return _regenerator().w(function (_context3) {
        while (1) switch (_context3.n) {
          case 0:
            params = createParamsForOneOffReport(getState, formValues);
            _t = formValues.type;
            _context3.n = _t === 'TradeActivity' ? 1 : _t === 'Transaction' ? 3 : _t === 'Treasury' ? 5 : _t === 'ProductDelta' ? 7 : _t === 'PnL' ? 9 : 11;
            break;
          case 1:
            _context3.n = 2;
            return dispatch((0, _apiActions.callAPI)('GenerateTradeActivityReport', params));
          case 2:
            response = _context3.v;
            return _context3.a(3, 12);
          case 3:
            _context3.n = 4;
            return dispatch((0, _apiActions.callAPI)('GenerateTransactionActivityReport', params));
          case 4:
            response = _context3.v;
            return _context3.a(3, 12);
          case 5:
            _context3.n = 6;
            return dispatch((0, _apiActions.callAPI)('GenerateTreasuryActivityReport', params));
          case 6:
            response = _context3.v;
            return _context3.a(3, 12);
          case 7:
            _context3.n = 8;
            return dispatch((0, _apiActions.callAPI)('GenerateProductDeltaActivityReport', params));
          case 8:
            response = _context3.v;
            return _context3.a(3, 12);
          case 9:
            _context3.n = 10;
            return dispatch((0, _apiActions.callAPI)('GeneratePnLActivityReport', params));
          case 10:
            response = _context3.v;
            return _context3.a(3, 12);
          case 11:
            console.error("Unsupported '".concat(formValues.type, "' report type"));
            return _context3.a(2);
          case 12:
            if (!(response.bAccepted === false)) {
              _context3.n = 13;
              break;
            }
            return _context3.a(2, dispatch((0, _snackbarActions.showSnack)({
              id: 'REPORT_WARNING',
              type: 'warning',
              text: response.rejectMessage
            })));
          case 13:
            dispatch(addReport(response));
            dispatch((0, _sidePaneActions.closeReportsSidePane)());
            dispatch((0, _snackbarActions.showSnack)({
              id: 'SINGLE_REPORT_SUCCESS',
              type: 'success',
              // t('Single report was successfully created')
              text: 'Single report was successfully created'
            }));
          case 14:
            return _context3.a(2);
        }
      }, _callee3);
    }));
    return function (_x4, _x5) {
      return _ref3.apply(this, arguments);
    };
  }();
};
var createParamsForScheduledReport = function createParamsForScheduledReport(getState, formValues) {
  var OMSId = getState().user.userInfo.OMSId;
  return {
    OMSId: OMSId,
    frequency: formValues.frequency,
    beginTime: formValues.startDate,
    accountIdList: formValues.accountIdList
  };
};
var scheduleReport = exports.scheduleReport = function scheduleReport(formValues) {
  return /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(dispatch, getState) {
      var params, response, _t2;
      return _regenerator().w(function (_context4) {
        while (1) switch (_context4.n) {
          case 0:
            params = createParamsForScheduledReport(getState, formValues);
            _t2 = formValues.type;
            _context4.n = _t2 === 'TradeActivity' ? 1 : _t2 === 'Transaction' ? 3 : _t2 === 'Treasury' ? 5 : _t2 === 'ProductDelta' ? 7 : _t2 === 'PnL' ? 9 : 11;
            break;
          case 1:
            _context4.n = 2;
            return dispatch((0, _apiActions.callAPI)('ScheduleTradeActivityReport', params));
          case 2:
            response = _context4.v;
            return _context4.a(3, 12);
          case 3:
            _context4.n = 4;
            return dispatch((0, _apiActions.callAPI)('ScheduleTransactionActivityReport', params));
          case 4:
            response = _context4.v;
            return _context4.a(3, 12);
          case 5:
            _context4.n = 6;
            return dispatch((0, _apiActions.callAPI)('ScheduleTreasuryActivityReport', params));
          case 6:
            response = _context4.v;
            return _context4.a(3, 12);
          case 7:
            _context4.n = 8;
            return dispatch((0, _apiActions.callAPI)('ScheduleProductDeltaActivityReport', params));
          case 8:
            response = _context4.v;
            return _context4.a(3, 12);
          case 9:
            _context4.n = 10;
            return dispatch((0, _apiActions.callAPI)('ScheduleProfitAndLossActivityReport', params));
          case 10:
            response = _context4.v;
            return _context4.a(3, 12);
          case 11:
            console.error("Unsupported '".concat(formValues.type, "' report type"));
            return _context4.a(2);
          case 12:
            if (!(response.bAccepted === false)) {
              _context4.n = 13;
              break;
            }
            return _context4.a(2, dispatch((0, _snackbarActions.showSnack)({
              id: 'CYCLICAL_REPORT_ERROR',
              type: 'warning',
              text: response.rejectMessage
            })));
          case 13:
            dispatch(addReport(response));
            dispatch((0, _sidePaneActions.closeReportsSidePane)());
            dispatch((0, _snackbarActions.showSnack)({
              id: 'CYCLICAL_REPORT_SUCCESS',
              type: 'success',
              // t('Cyclical report was successfully created')
              text: 'Cyclical report was successfully created'
            }));
          case 14:
            return _context4.a(2);
        }
      }, _callee4);
    }));
    return function (_x6, _x7) {
      return _ref4.apply(this, arguments);
    };
  }();
};
var addReport = exports.addReport = function addReport(payload) {
  return {
    type: ADD_REPORT,
    payload: payload
  };
};
var cancelReport = exports.cancelReport = function cancelReport(UserReportId) {
  return /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(dispatch, getState) {
      var UserId, response;
      return _regenerator().w(function (_context5) {
        while (1) switch (_context5.n) {
          case 0:
            UserId = getState().user.userInfo.UserId;
            _context5.n = 1;
            return dispatch((0, _apiActions.callAPI)('CancelUserReport', {
              UserReportId: UserReportId
            }));
          case 1:
            response = _context5.v;
            if (response.result) {
              dispatch(getUserReports(UserId));
            } else {
              dispatch((0, _snackbarActions.showSnack)({
                id: 'CANCEL_REPORT_ERROR',
                text: (0, _errorTextFormatter.formatErrorText)(response),
                type: 'warning'
              }));
            }
          case 2:
            return _context5.a(2);
        }
      }, _callee5);
    }));
    return function (_x8, _x9) {
      return _ref5.apply(this, arguments);
    };
  }();
};